<div class="header" [attr.data-type]="type">
    <div class="header-left">
        <a class="back" routerLink="../select">
            <i class="pi pi-arrow-left"></i>
        </a>
        <h2>{{ title() }}</h2>
    </div>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'lessons.fieldset.basic' | translate }}</h2>
        <app-form-input [control]="form.controls.name" [label]="'lessons.form.name' | translate" inputId="name" testId="lessons-add-name" />
        <app-form-number
            [control]="form.controls.duration"
            [label]="'lessons.form.duration' | translate"
            inputId="duration"
            [min]="0"
            testId="lessons-add-duration"
        />
    </div>

    @if (type === 'video' || type === 'audio') {
        <div class="section">
            <h2>{{ 'lessons.fieldset.media' | translate }}</h2>

            @if (type === 'video') {
                <div class="media-row">
                    <div class="media-field">
                        <span class="label">{{ 'lessons.form.media' | translate }}</span>
                        @if (form.controls.mediaId.value; as mediaId) {
                            <div class="video-preview">
                                <app-media-video [mediaId]="mediaId" (durationLoaded)="updateDuration($event)" />
                            </div>
                        }
                        <p-button
                            [label]="'lessons.form.selectMedia' | translate"
                            icon="pi pi-search"
                            [outlined]="true"
                            severity="secondary"
                            (onClick)="onSelectMedia('mediaId', 'video')"
                        />
                        <app-form-error [errors]="form.controls.mediaId.errors" [visible]="form.controls.mediaId.touched && !!form.controls.mediaId.errors" />
                    </div>
                    <div class="media-field">
                        <span class="label">{{ 'lessons.form.placeholder' | translate }}</span>
                        @if (form.controls.mediaPlaceholderId.value; as placeholderId) {
                            <div class="media-preview">
                                <app-media-image [mediaId]="placeholderId" [alt]="'lessons.form.placeholder' | translate" />
                            </div>
                        }
                        <p-button
                            [label]="'lessons.form.selectThumbnail' | translate"
                            icon="pi pi-image"
                            [outlined]="true"
                            severity="secondary"
                            (onClick)="onSelectMedia('mediaPlaceholderId', 'image')"
                        />
                        <app-form-error
                            [errors]="form.controls.mediaPlaceholderId.errors"
                            [visible]="form.controls.mediaPlaceholderId.touched && !!form.controls.mediaPlaceholderId.errors"
                        />
                    </div>
                </div>
            } @else {
                <div class="media-field">
                    @if (form.controls.mediaId.value; as mediaId) {
                        <div class="media-preview">
                            <app-media-audio [mediaId]="mediaId" (durationLoaded)="updateDuration($event)" />
                        </div>
                    }
                    <p-button
                        [label]="'lessons.form.selectMedia' | translate"
                        icon="pi pi-search"
                        [outlined]="true"
                        severity="secondary"
                        (onClick)="onSelectMedia('mediaId', 'audio')"
                    />
                    <app-form-error [errors]="form.controls.mediaId.errors" [visible]="form.controls.mediaId.touched && !!form.controls.mediaId.errors" />
                </div>
            }
        </div>

        <div class="section">
            <h2>{{ 'lessons.fieldset.transcription' | translate }}</h2>
            <app-form-wysiwyg
                [control]="form.controls.transcription"
                [label]="'lessons.form.transcription' | translate"
                inputId="transcription"
                [placeholder]="'lessons.form.transcription.placeholder' | translate"
                [mediaBlocks]="false"
                testId="lessons-add-transcription"
            />
        </div>

        @if (type === 'video') {
            <div class="section">
                <h2>{{ 'lessons.fieldset.progression' | translate }}</h2>
                <app-form-toggle-switch
                    [control]="form.controls.completionEnforcement"
                    [label]="'lessons.form.completionEnforcement' | translate"
                    [description]="'lessons.form.completionEnforcement.description' | translate"
                    inputId="completionEnforcement"
                    testId="lessons-add-completion-enforcement"
                />
            </div>
        }
    }

    @if (type === 'text') {
        <div class="section">
            <h2>{{ 'lessons.fieldset.content' | translate }}</h2>
            <div class="media-field">
                @if (form.controls.mediaId.value; as mediaId) {
                    <div class="media-preview">
                        <app-media-text [mediaId]="mediaId" />
                    </div>
                }
                <p-button
                    [label]="'lessons.form.selectContent' | translate"
                    icon="pi pi-file-edit"
                    [outlined]="true"
                    severity="secondary"
                    (onClick)="onSelectMedia('mediaId', 'text')"
                />
                <app-form-error [errors]="form.controls.mediaId.errors" [visible]="form.controls.mediaId.touched && !!form.controls.mediaId.errors" />
            </div>
        </div>
    }

    <app-material-list
        [materialIds]="form.controls.materialIds.value"
        titleKey="lessons.fieldset.materials"
        addLabelKey="lessons.form.addMaterial"
        emptyKey="lessons.materials.empty"
        testId="lessons-add-materials"
        (add)="onSelectMedia('materialIds', 'pdf')"
        (remove)="removeMaterial($event)"
        (reorder)="reorderMaterials($event)"
    />
</form>

<div class="footer">
    <p-button [label]="'lessons.form.cancel' | translate" [outlined]="true" severity="secondary" (onClick)="close()" />
    <p-button type="submit" [label]="'lessons.form.create' | translate" [loading]="saving()" [disabled]="form.disabled" (onClick)="onSubmit()" />
</div>
